import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { GET_ROOTNODES } from "../queries/Nodes";

interface IDuplicateModel {
    variables?: {
        source: number;
        destination: string;
    };
}

export const DUPLICATE_MODEL = gql`
    mutation UseDuplicateModel($source: Int!, $destination:String!) {
        duplicateModel(source:$source, destination:$destination )
    }
`;
const useDuplicateModel = ({ variables }: IDuplicateModel) => {
    return useMutation(DUPLICATE_MODEL, {
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [{ query: GET_ROOTNODES }],
    });
};
export { useDuplicateModel };
